import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import ShareButton from '../../../components/ui/ShareButton';
import useFavorites from '../../../hooks/useFavorites';

const ThingInfo = ({ thing }) => {
  const { toggleFavorite, isProductFavorited, loading } = useFavorites();
  const [isLiked, setIsLiked] = useState(false);

  React.useEffect(() => {
    if (thing?.id) {
      setIsLiked(isProductFavorited(thing.id, 'thing'));
    }
  }, [thing?.id, isProductFavorited]);

  const handleToggleFavorite = async () => {
    if (!thing?.id || loading) return;
    
    const result = await toggleFavorite(thing.id, 'thing');
    if (result.success) {
      setIsLiked(result.isFavorited);
    }
  };

  if (!thing) return null;

  return (
    <div className="space-y-3 sm:space-y-4">
      {/* Title */}
      <div>
        <h1 className="text-lg sm:text-2xl lg:text-3xl font-heading font-bold text-foreground leading-tight">
          {thing.title}
        </h1>
      </div>

      {/* Availability Status */}
      <div className={`p-3 border rounded-lg ${
        thing.available 
          ? 'bg-success/10 border-success/20' 
          : 'bg-destructive/10 border-destructive/20'
      }`}>
        <div className="flex items-center justify-center space-x-2">
          <Icon 
            name={thing.available ? 'CheckCircle' : 'XCircle'} 
            size={18} 
            className={thing.available ? 'text-success' : 'text-destructive'} 
          />
          <span className={`font-medium text-sm ${
            thing.available ? 'text-success' : 'text-destructive'
          }`}>
            {thing.available ? 'Disponible' : 'No disponible'}
          </span>
        </div>
      </div>

      {/* Price Section */}
      {thing.price && thing.price > 0 && (
        <div className="pt-4 border-t border-border">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-baseline gap-3">
              <span className="text-lg text-muted-foreground">Precio:</span>
              <span className="text-xl sm:text-3xl font-bold text-primary">
                ${thing.price.toFixed(2)}
              </span>
              {thing.originalPrice && thing.originalPrice > thing.price && (
                <span className="text-lg text-muted-foreground line-through">
                  ${thing.originalPrice.toFixed(2)}
                </span>
              )}
            </div>
            <ShareButton
              title={thing.title}
              description={`Accesorio para librería`}
              price={thing.price}
              productType="accesorio"
            />
          </div>
        </div>
      )}

      {/* Favorites Button */}
      <Button
        onClick={handleToggleFavorite}
        className="w-full transition-colors duration-200 border"
        style={{
          backgroundColor: !isLiked ? '#d96f00' : '',
          borderColor: !isLiked ? 'transparent' : '',
        }}
        onMouseEnter={(e) => {
          if (!isLiked) {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#d96f00';
            e.currentTarget.style.borderColor = '#d96f00';
            const icon = e.currentTarget.querySelector('.heart-icon');
            if (icon) icon.style.color = '#d96f00';
          }
        }}
        onMouseLeave={(e) => {
          if (!isLiked) {
            e.currentTarget.style.backgroundColor = '#d96f00';
            e.currentTarget.style.color = '#ffffff';
            e.currentTarget.style.borderColor = 'transparent';
            const icon = e.currentTarget.querySelector('.heart-icon');
            if (icon) icon.style.color = '#ffffff';
          }
        }}
      >
        <Icon
          name="Heart"
          size={20}
          className="mr-2 heart-icon"
          style={{
            color: !isLiked ? '#d96f00' : '#d96f00',
            transition: 'color 0.2s ease',
          }}
        />
        {isLiked ? 'Quitar de Favoritos' : 'Agregar a Favoritos'}
      </Button>

      {/* Description */}
      {thing.description && (
        <div className="pt-4 border-t border-border">
          <h3 className="font-semibold text-foreground mb-2">Descripción</h3>
          <p className="text-muted-foreground leading-relaxed">
            {thing.description}
          </p>
        </div>
      )}
    </div>
  );
};

export default ThingInfo;

